/**************************************************
 * Nombre:       Home_Preguntas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Checkbox, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_preguntas.png'
import fondo_preguntas_cell from '../../../Recursos/fondo_preguntas_cell.png'
import fondo_agendar from '../../../Recursos/fondo_agendar.png'
import {NEGRITA, PREGUNTAS} from "../../../Constantes";
import linea from "../../../Recursos/Iconos/ic_raya.svg"
import Tarjeta_Preguntas from "../../Tarjetas/Tarjeta_Preguntas";
import {theme} from "../../../Tema";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Asesoria from "../../Formularios/Formulario_Asesoria";
import {East} from "@mui/icons-material"
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useState} from "react";


const Home_Preguntas = () => {
    const {sCell, masSM} = useResponsive()
    const {props, obtenerEntidad, limpiarEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({logoRedondo: logo, funcionUno: setEntidad})
    const [acepto, setAcepto] = useState(true)

    const enviar = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Enviando Datos')
        entidad.estado = 'Nuevo'

        let dox = await guardarDoc('clientesPotenciales', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos enviados con exito, pronto nos contactaremos contigo'})
        } else {
            terminar({aviso: 'Algo indesperado paso, porfavor intentalo nuevamente', variante: 'error'})
        }


    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: sCell ? '' : 'url(' + fondo + ')',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
        >

            <Cargador/>

            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 3, py: 6}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 6}}
                            sx={{
                                p: 4,
                                color: '#fff',
                                pr: sCell ? 4 : 6,
                                backgroundImage: sCell ? 'url(' + fondo_preguntas_cell + ')' : '',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                            }}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 0}}>
                                <Typography sx={{
                                    fontSize: !masSM ? 32 : 48,
                                    fontFamily: NEGRITA,
                                    fontWeight: 400,
                                    lineHeight: 1.1
                                }}>PREGUNTAS
                                    FRECUENTES</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <img src={linea} alt="linea" width={40} height={'auto'}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                                <Typography sx={{fontSize: !masSM ? 16 : 18, fontWeight: 300}}>
                                    Respuestas técnicas sobre la operación de los Mecanismos Alternativos de Solución de
                                    Conflictos en nuestro Centro Privado
                                </Typography>
                            </Grid>


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 4}}
                            >

                                {PREGUNTAS.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Preguntas item={it}/>
                                    </Grid>
                                ))}


                            </Grid>


                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 6}}
                            sx={{
                                p: 4,
                                color: theme.palette.primary.main,
                                pl: 6,
                                backgroundImage: sCell ? 'url(' + fondo_agendar + ')' : '',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                            }}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 0}}>
                                <Typography sx={{
                                    fontSize: !masSM ? 32 : 48,
                                    fontFamily: NEGRITA,
                                    fontWeight: 400,
                                    lineHeight: 1.1
                                }}>CONSIGUE
                                    UNA
                                    ASESORÍA</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <img src={linea} alt="linea" width={40} height={'auto'}/>
                            </Grid>


                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Formulario_Asesoria props={props}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                <Typography>
                                    <Checkbox checked={acepto} onChange={() => setAcepto(!acepto)}
                                              sx={{mt: -0.2}}
                                    /> Acepto <span style={{textDecoration: 'underline', cursor: 'pointer'}}>
                                    politicas de
                                    tratamientos de datos
                                        </span>
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Button
                                    disabled={!acepto}
                                    onClick={() => enviar()}
                                    endIcon={<East/>}>
                                    Agendar ahora
                                </Button>
                            </Grid>


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Preguntas